export const getJWToken = async (code, locale, service) => {
  const url = process.env.REACT_APP_D_AUTH_ENDPOINT + "/dauth/"
  return await fetch(url, {
    method: "POST",
    headers: {
      "Content-Type": "application/json; charset=utf-8",
    },
    body: JSON.stringify({ code: code, locale: locale, service: service }),
  })
    .then(response => {
      if (response.ok) {
        return response.json()
      }
      throw response
    })
    .then(payload => ({ payload }))
    .catch(error => ({ error }))
}

export const refreshToken = async jwt => {
  const url = process.env.REACT_APP_D_AUTH_ENDPOINT + "/dauth/refreshToken"
  return await fetch(url, {
    method: "POST",
    headers: {
      Authorization: `Bearer ${jwt}`,
      "Content-Type": "application/json; charset=utf-8",
    },
  })
    .then(response => {
      if (response.ok) {
        return response.json()
      }
      throw response
    })
    .then(payload => ({ payload }))
    .catch(error => ({ error }))
}
